module.exports = __webpack_public_path__ + "img/qrcodetype1.ce22bd1e.png";